import { type AdminProfile, type UUID } from "@/core/types";
import { isCseProfile } from "@/core/helpers/(predicates)/adminProfile";
import { isLcsw } from "@/core/helpers/(predicates)/lcsw";
import { useUserPermissions } from "@/features/permissions/api/queries/useUserPermissions";

import { LcswPermissionCard } from "./LcswPermissionCard";
import { LcswPermissionSkeleton } from "./LcswPermissionSkeleton";

type LcswPermissionSelfProps = {
  profileData: AdminProfile;
  userId: UUID;
};

// self-view: always fetch the target's own permissions to reflect the real is_lcsw status on
// the read-only switch — no can_grant_lcsw check needed since viewing your own status doesn't
// require grant privileges
export function LcswPermissionSelf({ profileData, userId }: LcswPermissionSelfProps) {
  const isCse = isCseProfile(profileData);
  const { data: permissions, isLoading } = useUserPermissions({ enabled: isCse, userId });

  if (!isCse) return null;
  if (isLoading) return <LcswPermissionSkeleton />;

  return (
    <LcswPermissionCard
      isLcsw={isLcsw(permissions)}
      isReadOnly
      userId={userId}
      userName={profileData.name}
    />
  );
}
